/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "Anuluj"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "Masz uzasadnienie biznesowe dotyczące uzyskiwania dostępu do danych klientów."
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "Twoja aktywność związana z pobieraniem będzie rejestrowana i śledzona w celu zapewnienia zgodności z wymogami dotyczącymi bezpieczeństwa."
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "Czy chcesz kontynuować?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "Pobierając dane, przyjmujesz do wiadomości, że:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
